module.exports = __webpack_public_path__ + "img/trend-up.17b65131.svg";